import {WorkflowCspOneUpgradeCuComponent} from "./workflow-csp-one-upgrade-cu/workflow-csp-one-upgrade-cu.component";
import {WorkflowCspOneUpgradeSlaComponent} from "./workflow-csp-one-upgrade-sla/workflow-csp-one-upgrade-sla.component";
import {
  WorkflowCspOneDowngradeCuComponent
} from "./workflow-csp-one-downgrade-cu/workflow-csp-one-downgrade-cu.component";
import {
  WorkflowCspOneDowngradeSlaComponent
} from "./workflow-csp-one-downgrade-sla/workflow-csp-one-downgrade-sla.component";
import {WorkflowCspService} from "./workflow-csp.service";
import {
  WorkflowCspOneTrialCreateComponent
} from "./workflow-csp-one-trial-create/workflow-csp-one-trial-create.component";
import { WorkflowCspAddTrialPhonenumberComponent } from "./workflow-csp-add-trial-phonenumber/workflow-csp-add-trial-phonenumber.component";
import { WorkflowCspOneAvailabilityOrderCancelComponent } from "./workflow-csp-one-availability-order-cancel/workflow-csp-one-availability-order-cancel.component";
import { WorkflowCspOneAvailabilityComponent } from "./workflow-csp-one-availability/workflow-csp-one-availability.component";
import { WorkflowCspOneTariffComponent } from "./workflow-csp-one-tariff/workflow-csp-one-tariff.component";
import { WorkflowCspOneTariffOrderCancelComponent } from "./workflow-csp-one-tariff-order-cancel/workflow-csp-one-tariff-order-cancel.component";
import { WorkflowCspOneCancelPhonenumberComponent } from "./workflow-csp-one-cancel-phonenumber/workflow-csp-one-cancel-phonenumber.component";
import { WorkflowCspAiTariffComponent } from "./workflow-csp-ai-tariff/workflow-csp-ai-tariff.component";
import { WorkflowCspAiTariffOrderCancelComponent } from "./workflow-csp-ai-tariff-order-cancel/workflow-csp-ai-tariff-order-cancel.component";

export const workflowCspComponents= [
  WorkflowCspOneUpgradeCuComponent,
  WorkflowCspOneUpgradeSlaComponent,
  WorkflowCspOneDowngradeCuComponent,
  WorkflowCspOneDowngradeSlaComponent,
  WorkflowCspOneTrialCreateComponent,
  WorkflowCspAddTrialPhonenumberComponent,
  WorkflowCspOneAvailabilityOrderCancelComponent,
  WorkflowCspOneAvailabilityComponent,
  WorkflowCspOneTariffComponent,
  WorkflowCspOneTariffOrderCancelComponent,
  WorkflowCspOneCancelPhonenumberComponent,
  WorkflowCspAiTariffComponent,
  WorkflowCspAiTariffOrderCancelComponent
]

export const workflowCspServices = [
  WorkflowCspService,
]
